import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  standalone: false,
  selector: 'app-answer-check-modal',
  templateUrl: './answer-check-modal.component.html',
  styleUrls: ['./answer-check-modal.component.scss']
})
export class AnswerCheckModalComponent implements OnInit {

  @Input() answerDescription: string;
  @Input() isCorrect: boolean;
  @Input() correctAnswer: string;
  @Input() ansDescriptionImgs: string[]
  @Input() isLastQuesion: boolean;
  @Input() isFirstQuestion: boolean;
  @Output() prevQuestionEvt = new EventEmitter<void>();
  @Output() nextQuestionEvt = new EventEmitter<void>();
  correctStatus: string;
  imageUrl: string;

  constructor(private activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.updateModalContent()
  }

  updateModalContent(): void {
    if (this.isCorrect) {
      this.correctStatus = "Great...That's Correct!"
      this.imageUrl = '../../../../../assets/img/Layer_1.png'
    } else {
      this.correctStatus = "Oops...That's Incorrect!"
      this.imageUrl = '../../../../../assets/img/Frame 1000004242.png'
    }
  }

  togglePrevQuestion(): void {
    this.prevQuestionEvt.emit();
    this.activeModal.close()
  }
  toggleNextQuestion(): void {
    this.nextQuestionEvt.emit();
    this.activeModal.close()
  }

}
